import { render, staticRenderFns } from "./AEBasketClassic.vue?vue&type=template&id=cfcb614a&"
import script from "./AEBasketClassic.vue?vue&type=script&lang=js&"
export * from "./AEBasketClassic.vue?vue&type=script&lang=js&"
import style0 from "./AEBasketClassic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports